export default {
    props: {
        messagesCommandsCanceledit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.canceledit'
        }, 
        messagesCommandsCreate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.create'
        }, 
        messagesCommandsCreatechild: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.createchild'
        }, 
        messagesCommandsDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.destroy'
        }, 
        messagesCommandsEdit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.edit'
        }, 
        messagesCommandsExcel: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.excel'
        }, 
        messagesCommandsPdf: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.pdf'
        }, 
        messagesCommandsUpdate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.update'
        }, 
        messagesLoading: {
            type: String,
            default: undefined,
            kComposite: 'messages.loading'
        }, 
        messagesNoRows: {
            type: String,
            default: undefined,
            kComposite: 'messages.noRows'
        }, 
        messagesRequestFailed: {
            type: String,
            default: undefined,
            kComposite: 'messages.requestFailed'
        }, 
        messagesRetry: {
            type: String,
            default: undefined,
            kComposite: 'messages.retry'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Messages.js